<template>
    <div>
        <div v-if="service.length">
            <table class="table">
                <thead class="thead-dark">
                    <tr>
                    <th scope="col">#</th>
                    <th scope="col">Имя</th>
                    <th scope="col">Заголовок</th>
                    <th scope="col"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in service" :key="item.id">
                        <th scope="row">{{ item.id }}</th>
                        <td>{{ item.name[lang()] }}</td>
                        <td>{{ item.header[lang()] }}</td>
                        <td>
                            <button class="btn btn-info" @click="edit(item)">
                                <img src="../../assets/edit.png" title="edit" style="width: 20px;">
                            </button>
                            <button class="btn btn-danger" @click="delModal(item)">
                                <img src="../../assets/clean.png" title="delete" style="width: 20px;">
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div v-else style="text-align: center; padding: 1rem; color: grey;">
            <span>ПУСТО</span>
        </div>
        <div>
            <button class="btn btn-success" 
                style="width: 100%"
                @click="add"
            >
                добавить
            </button>
        </div>

        <modal v-if="showAddModal" @off="showAddModal = false;">
            <addService @saved="saved" />
        </modal>
        <modal v-if="showDeleteModal" @off="showDeleteModal = false">
            <deleteService :delData="delData" @del="del" />
        </modal>
        <modal v-if="showEditModal" @off="showEditModal = false">
            <editService :editData="editData" @saved="saveEdit" />
        </modal>
    </div>
</template>

<script>
import { store } from '../../store';

import modal from '../modal.vue';
import addService from './addService.vue';
import deleteService from './deleteService.vue';
import editService from './editService.vue';
import Data from '../../API';
export default {
    components: {
        modal,
        addService,
        deleteService,
        editService
    },
    data() {
        return {
            showAddModal: false,
            showDeleteModal: false,
            delData: null,
            editData: null,
            showEditModal: false
        }
    },
    methods: {
        updateData() {
            Data.getStart()
                .then(json => {
                    store.getStart = json.data.data;
                })
        },
        lang() {
            return localStorage.getItem('lang')
        },
        add() {
            this.showAddModal = true;
        },
        del() {
            this.showDeleteModal = false;
            this.updateData();
        },
        saved() {
            this.showAddModal = false;
            this.updateData();
        },
        saveEdit() {
            this.showEditModal = false;
            this.updateData();
        },
        delModal(item) {
            this.delData = item;
            this.showDeleteModal = true;
        },
        edit(item) {
            this.editData = item;
            this.showEditModal = true;
        }
    },
    computed: {
        service() {
            return store.getStart.service_data
        }
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/service/ServicesAdmin.vue